import RingBuffer from 'ringbufferjs';
import { EventStatsBuffer } from './eventStatsBuffer';
import { MfsTelemetryBuffer } from './mfsTelemetryBuffer';
export const VERBOSE_BUFFER_SIZE = 100;
/** Container for all log buffers. */
export class BufferContainer {
    constructor() {
        this.errorBuffer = new MfsTelemetryBuffer('errorBuffer');
        this.warnBuffer = new MfsTelemetryBuffer('warnBuffer');
        this.infoBuffer = new MfsTelemetryBuffer('infoBuffer');
        this.activityBuffer = new MfsTelemetryBuffer('activityBuffer');
        this.metricBuffer = new MfsTelemetryBuffer('metricBuffer');
        this.verboseBuffer = new RingBuffer(VERBOSE_BUFFER_SIZE);
        this.eventStatsBuffer = new EventStatsBuffer();
    }
    /** Returns flushable buffers. */
    get flushableBuffers() {
        return [this.errorBuffer, this.warnBuffer, this.infoBuffer, this.activityBuffer];
    }
    /** Returns the verbose logs to be sent to telemetry. */
    getVerboseLogsToSend() {
        const allBufferedEvents = this.verboseBuffer.isEmpty() ? [] : this.verboseBuffer.peekN(this.verboseBuffer.size());
        return [...allBufferedEvents];
    }
}
//# sourceMappingURL=bufferContainer.js.map